<template>
  <div class="top-right">
    {{msg}}
  </div>
</template>

<script>
export default {
  name: 'ErrorBox',
  props: {
    msg: String
  }
}
</script>

<style scoped>
.top-right {
  position:absolute;
  top:85px;
  right:15px;
  background:white;
  border:2px dashed red;
  min-height:270px;
  min-width:300px;
  z-index:3;
}

</style>
